function $parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
function $parcel$defineInteropFlag(a) {
    Object.defineProperty(a, '__esModule', {
        value: true,
        configurable: true
    });
}
function $parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $parcel$global = globalThis;
var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("blyWx", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "default", ()=>$03c7b9213b166589$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $3RV1W;
    var $7tQej;
    var $jDDFr;
    const $03c7b9213b166589$var$QueuesIssueViewRedirect = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3RV1W")).LicenseCheck), {
            type: "servicedesk"
        }, ({ result: result })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jDDFr")).RouterSubscriber), null, ({ match: match })=>match && match.params && match.params.issueKey ? result ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7tQej")).Redirect), {
                    to: `/jira/servicedesk/projects/${String(match.params.projectKey)}/queues/issue/${String(match.params.issueKey)}`
                }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7tQej")).Redirect), {
                    to: `/browse/${String(match.params.issueKey)}`
                }) : null));
    var $03c7b9213b166589$export$2e2bcd8739ae039 = $03c7b9213b166589$var$QueuesIssueViewRedirect;
});
parcelRegister("3RV1W", function(module, exports) {
    $parcel$export(module.exports, "checkLicense", ()=>$6334356fa938c5d8$export$fe2591be8b7e59ce);
    $parcel$export(module.exports, "LicenseCheck", ()=>$6334356fa938c5d8$export$944be0b3bf2a6feb);
    var $5uXOq = parcelRequire("5uXOq");
    var $9OXo1;
    const $6334356fa938c5d8$var$appPermissionMapper = {
        software: 'hasSoftwareAccess',
        servicedesk: 'hasServiceDeskAccess'
    };
    const $6334356fa938c5d8$export$fe2591be8b7e59ce = (tenantContext, type)=>Boolean(tenantContext.appPermissions && tenantContext.appPermissions[$6334356fa938c5d8$var$appPermissionMapper[type]]);
    const $6334356fa938c5d8$export$944be0b3bf2a6feb = ({ children: children, type: type })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9OXo1")).TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>{
            const result = $6334356fa938c5d8$export$fe2591be8b7e59ce(tenantContext, type);
            return children({
                result: result
            });
        });
});
